import styled from '@emotion/styled';
import type { TrackerPrototype } from '@racemap/sdk/schema/trackers';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Button } from 'antd';
import { type FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../../store/reducers';
import { IconPlus } from '../../Icon';
import { AddTrackersModal } from './AddTrackersModal';
import { CreateTrackersModal } from './CreateTrackerModal';

export const CreateTrackerButton: FC = () => {
  const { addTrackers } = useStore((s) => s.trackers.actions);

  const handleCreateNewTrackers = async (trackerPrototypes: Array<TrackerPrototype>) => {
    await addTrackers(trackerPrototypes);
  };

  const [isAddTrackersModalOpen, setIsAddTrackersModalOpen] = useState(false);
  const [trackersToAdd, setTrackersToAdd] = useState<Array<TrackerPrototype> | null>(null);

  return (
    <>
      <AddTrackersModal
        trackersToAdd={trackersToAdd}
        setTrackersToAdd={setTrackersToAdd}
        isAddTrackersModalOpen={isAddTrackersModalOpen}
        setIsAddTrackersModalOpen={setIsAddTrackersModalOpen}
        addTrackers={addTrackers}
      />
      <CreateTrackersModal
        triggerElement={
          <Link to="/admin/trackers/add">
            <TrackerButton size="small">
              <IconPlus className="icon-plus" />
              &nbsp;Add Tracker
            </TrackerButton>
          </Link>
        }
        onCreateNewTracker={handleCreateNewTrackers}
        setIsAddTrackersModalOpen={setIsAddTrackersModalOpen}
        setTrackersToAdd={setTrackersToAdd}
      />
    </>
  );
};

const TrackerButton = styled(Button)`
  background-color: ${RacemapColors.CloudBlue};
  white-space: nowrap;
  .icon-plus{
    color: inherit;
  }
`;
